import React, { memo } from 'react';
import CloseModal from '../Usables/CloseModal';
import NoRecords from '../Usables/NoRecords';
import { formatDate, formatDateOnly, formatDateTime } from '../Constants/constant';

const PositionFollowUpHistory = memo(({loading, onClose, data}) => {
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[80vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Position Foliow Up History</h1>
                {data?.length >= 1 ?
                <div className='tableWrapper'>
                    <div className='tableBody'>
                        <table className='w-full table-fixed border-collapse'>
                            <thead className='tableHead'>
                                <tr className=' text-left'>
                                    <th className=' w-[5%] text-center'>Sr. No.</th>
                                    <th className='w-[18%] whitespace-nowrap text-center'>Log Date</th>
                                    <th className='w-[15%] whitespace-nowrap text-center'>Last Follow Up Date</th>
                                    <th className='w-[15%] whitespace-nowrap text-center'>Status</th>
                                    <th className=''>Remark</th>
                                    <th className='w-[15%] whitespace-nowrap'>Action By</th>
                                </tr>
                            </thead>
                            <tbody className='tableBody  '>
                                {
                                    data?.map((val, idx) => {
                                        return (
                                            <tr className=' text-left'>
                                                <td className=' text-center'>{idx + 1}</td>
                                                <td className=' text-center'>{val?.created_date?.includes(':') ? formatDateTime(val?.created_date) : formatDateOnly(val?.created_date) }</td>
                                                <td className=' text-center'>{val?.last_follow_up_date?.includes(':') ? formatDate(val?.last_follow_up_date) : formatDateOnly(val?.last_follow_up_date) }</td>
                                                <td className=' text-center'> <span
                                                className={`${
                                                    val?.follow_up_status === 1
                                                    ? " batch-warning"
                                                    : val?.follow_up_status === 2
                                                    ? "batch-success"
                                                    : "batch-info"
                                                } font-medium px-3 py-1 rounded-full`}
                                                >
                                                {val?.follow_up_status === 2 ? "Done" : "Missed"}
                                                </span></td>
                                                <td className=' text-wrap'>{val?.remarks || "--"}</td>
                                                <td>{val?.User?.name || "--"}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div> :
                <NoRecords/>}
            </div>
        </div>
    );
})

export default PositionFollowUpHistory;
